import { render, staticRenderFns } from "./TariffDetail.vue?vue&type=template&id=21662e9a&scoped=true"
import script from "./TariffDetail.vue?vue&type=script&lang=js"
export * from "./TariffDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21662e9a",
  null
  
)

export default component.exports